module.exports = __webpack_public_path__ + "static/media/doc.d9389f88.svg";